import React from "react";
import Profile2 from "./zzy3.jpg";

const About = () => {
  return (
    <div id="about-container" className="each-container">
      <div className="profile-container">
        <img src={Profile2} alt="./zzy.JPG" className="profile-img" />
      </div>

      <div className="about-part">
        <div id="about">
          <div className="about-hi">
            Hi, I'm <span className="hi-name">Zhongyue "Sherley" Zhang // 张钟月</span>
          </div>
          <br></br>
          <div className="self-intro">
            <div>
              I am a third-year PhD candidate at{" "}
              <b>
                The Hong Kong University of Science and Technology (Guangzhou)
              </b>, advised by {" "}
              <a href="https://www.mingmingfan.com" target="_blank">
                Prof. Mingming Fan
              </a>{" "} and co-advised by Prof. Xu Zhang. My research focuses on human-AI interaction, designing technologies that support people's everyday health and well-being.
              Much of my current work centers on aging, focusing on older adults' reminiscence, social connectedness, and care.</div>
            <br></br>
            <div>
              I was a Master's student in the Design Engineering program at Brown University and Rhode Island School of Design (RISD). I earned my two
              Bachelor's and a minor with <em>Magna Cum Laude</em> from University of Southern California.
            </div>

            <br></br>
            <div>
            Feel free to reach out if you'd like to collaborate:{" "}
              zzhang837@connect.hkust-gz.edu.cn
            </div>
            <br></br>
            <div className="social-media">
              <a 
              href="https://scholar.google.com/citations?user=0zAiggUAAAAJ" 
              class="fa fa-google fa-lg"
              target="_blank"></a>
              <a
                href="https://www.linkedin.com/in/zhongyue-zhang/"
                class="fa fa-linkedin fa-lg"
                target="_blank"
              ></a>
              <a
                href="https://www.instagram.com/sherley.zhang/"
                class="fa fa-instagram fa-lg"
                target="_blank"
              ></a>
              <a class="fa fa-github fa-lg"></a>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
